import { API_BASE_URL } from './ApiService';
import { ownAccessToken } from './accessToken';

/**
 * D-0347, ADR-175: this Mac's machine key is registered with the deployment for as long as the app is
 * signed in, so sign-out has to take it away again (AC-MK.5).
 *
 * The reporter says which machine it registered the key for; sign-out reads that here, in the same
 * tick, because the access token that proves whose machine it is is cleared a moment later. Kept apart
 * from `browserWatchReporter` and `signOut` so neither imports the other.
 */
let registeredMachineId: string | null = null;
let epoch = 0;

/** The reporter registered the key for this machine (or found it already registered). */
export function rememberRegisteredMachine(machineId: string): void {
  registeredMachineId = machineId;
}

/**
 * Changes at every sign-out, so the reporter's "nothing changed since the last report" does not hold
 * across one: the next person to sign in on this run registers the key afresh.
 */
export function registrationEpoch(): number {
  return epoch;
}

/**
 * Sign-out: ask the deployment to forget this machine's key and what it could do. Started in the
 * caller's tick like the logout beside it (`signOut.ts`), with `keepalive` so it outlives the page,
 * and never awaited: a failure leaves the key to the next run, which replaces it. Nothing to do when
 * this run never registered one.
 */
export function unregisterMachineKeyAtSignOut(): void {
  const machineId = registeredMachineId;
  registeredMachineId = null;
  epoch += 1;
  const accessToken = ownAccessToken();
  if (!machineId || !accessToken) return;
  try {
    void fetch(`${API_BASE_URL}/terminal-watch/machines/${encodeURIComponent(machineId)}/key`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${accessToken}` },
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // A fetch that throws in the call must not stop the sign-out it accompanies.
  }
}
